import React, { MouseEventHandler, useEffect, useRef } from "react";
import { BsPersonDash } from "react-icons/bs";
import { FaTimes } from "react-icons/fa";

type Props = {
    title: string,
    linkVideo: string,
    onCloseClick: MouseEventHandler<HTMLButtonElement>,
    visible: boolean,
}



export const ModalTutorial = React.memo( ({title, linkVideo, visible, onCloseClick}: Props) => {   
    
    const videoRef = useRef<any>(null)

    useEffect(() => {
        if (visible && videoRef.current) {        
            videoRef.current.currentTime = 0
            videoRef.current.play()
        }
    }, [visible])
        
    return  <div id="modalTutorial" style={{ visibility: visible ? "visible" : "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>                               
               <div id="modal-content" className={`relative flex flex-col w-3/4 h-3/4 bg-white dark:bg-slate-600 rounded-lg shadow-lg shadow-slate-700/80 ${visible ? 'mt-24' : 'mt-[-400px]'} transition-all duration-300 justify-center items-center`}>
                    <div className={`w-full h-[60px] flex items-center justify-between bg-slate-100`}>

                        <div className="flex items-center mx-4">
                            <BsPersonDash className="text-3xl mr-2"/>
                            <span className="text-xs md:text-xl lg:text-xl font-bold">{title}</span>
                        </div>
                        
                        <button onClick={onCloseClick} className="w-10 h-10">
                            <FaTimes />
                        </button>                        
                    </div>
                    <video ref={videoRef} className="w-full h-full" controls>
                        <source src={linkVideo} type="video/mp4"></source>
                    </video>
               </div>                
            </div>
} )